export default {
      id: "bitcoin-usage",
      viewBox: "0 0 10 14",
      url: __webpack_public_path__ + "img/svg.c2d72070.svg#bitcoin",
      toString: function () {
        return this.url;
      }
    }